<ng-template #rt let-r="result" let-t="term">
  <ngb-highlight [result]="r.HSN_CODE + '  ' + r.DDC_CODE + ' - ' + r.TRADE_NAME" [term]="t"></ngb-highlight>
</ng-template>

<app-page-header [heading]="'New Purchase'" [icon]="'fa-plus'" style="height:100px;"></app-page-header>
<div *ngIf="user_rights.ADD == '1'" class="page-panel">
  <div class="row">
    <div class="form-group col-lg-3">
      <label>Supplier Name</label><span class="text-danger">&nbsp;*</span>
      <ngx-select-dropdown (change)="getVendor($event);listOrderNo();" [(ngModel)]="vendor_data"
                           [config]="utils.dropConfig({displayKey: 'VENDOR_NAME',placeholder: 'Select supplier',searchOnKey: 'VENDOR_NAME'})"
                           [multiple]="false"
                           [options]="vendor_options" class="form-control  select-dropdown"
                           name="vendor"></ngx-select-dropdown>
    </div>
    <div class="form-group col-lg-3">
      <label>Invoice Number</label><span class="text-danger">&nbsp;*</span>
      <input [(ngModel)]="purchase.invoice_no" class="form-control " maxlength="15" name="invoice"
             type="text">
    </div>
    <div class="form-group col-lg-3">
      <label>PO Number</label>
      <ng-multiselect-dropdown (onDeSelect)="onItemSelect()"
                               (onDeSelectAll)="onSelectAll($event)"
                               (onFilterChange)="onItemSelect()"
                               (onSelect)="onItemSelect()"
                               (onSelectAll)=" onSelectAll($event)"
                               [(ngModel)]="purchase.sor_no"
                               [data]="order_list"
                               [placeholder]="'Select Order Number'"
                               [settings]="dropdownSettings"
                               name="sor_no"
                               style="font-size: 13px;">
      </ng-multiselect-dropdown>

    </div>
    <div class="form-group col-lg-3">
      <label for="date">Invoice date</label><span class="text-danger">&nbsp;*</span>
      <input (ngModelChange)="purchase.invoice_date = $event" [max]="getToday()"
             [ngModel]="purchase.invoice_date | date:'yyyy-MM-dd' "
             class="form-control " id="date" name="date" type="date">
    </div>
    <div class="form-group col-lg-3">
      <label>Customer TRN</label>
      <input [(ngModel)]="purchase.customer_trn" [readOnly]="true" class="form-control " maxlength="20"
             name="customer_trn"
             tabindex="-1" type="text">
    </div>
    <div class="form-group col-lg-3">
      <label for="Date">Customer Reference</label>
      <input [(ngModel)]="purchase.customer_ref" class="form-control " maxlength="20" name="customer_ref"
             type="text">
    </div>
    <div class="form-group col-lg-3">
      <label for="Date">Sales Person</label>
      <input [(ngModel)]="purchase.sales_person" class="form-control " maxlength="20" name="sales_person"
             type="text">
    </div>
    <div class="form-group col-lg-3">
      <label>Attachments</label>
      <div>
        <input (change)="selectFiles($event)" accept=".jpg, .jpeg, .pdf, .png" id="upload_file" multiple
               name="upload_file"
               type="file">
        <div class="clearfix"></div>
        <ng-container *ngIf="fileName">
          <ng-container *ngFor="let file of fileName;let i=index">
            <label class="text-primary" style="font-size:11px;"><i
              class="fa fa-file"></i>&nbsp;&nbsp;{{ file.name }}</label>
            &nbsp;&nbsp;&nbsp;<button (click)="fileName.splice(i, 1);purchase.upload_file.splice(i, 1);"
                                      class="btn btn-small"
                                      style="font-size:11px;"><i class="fa fa-trash text-danger"></i></button>
            <div></div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
  <hr>
  <h5 class="list-header">Add Particular</h5>
  <div class="clearfix"></div>
  <div class="clearfix"></div>
  <div class=" form-group">
    <table class=" table tbl  table-bordered ">
      <thead>
      <tr class="text-center">
        <th class="text-center" width="1%"></th>
        <th>Item<span class="text-danger">*</span> / Warehouse<span class="text-danger">*</span></th>
        <th width="10%">UOM / PO Qty</th>
        <th width="10%"><span class="text-danger">&nbsp;*</span>Purchased Qty / Freebie Qty</th>
        <th width="10%"><span class="text-danger">&nbsp;*</span> Amount / Actual Rate</th>
        <th width="10%">VAT</th>
        <th width="10%"><span class="text-danger">&nbsp;*</span> Gross Amount / Unit Price<span class="text-danger">&nbsp;*</span>
        </th>
        <th width="7%"> Selling Price<span class="text-danger">&nbsp;*</span></th>
        <th width="1%">*</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let purchases of purchase_details;let i = index;">
        <td class="text-center"><input (click)="changeCheckbox(i)" [checked]="purchases.check == true" type="checkbox">
        </td>
        <td>
          <input (selectItem)="set_item_medicine($event,i)" [(ngModel)]="purchase.medicine_data[i]"
                 [class.is-invalid]="searchFailed"
                 [disabled]="purchases.check == false" [inputFormatter]="formatter"
                 [ngModelOptions]="{standalone: true}" [ngbTypeahead]="medicine_search"
                 [resultTemplate]="rt" class="form-control" id="typeahead-http{{i}}"
                 placeholder="Search Particular Name...." style="height: 29px;margin-bottom: 2px"
                 type="text"/>
          <select [(ngModel)]="purchase.warehouse[i]"
                  class="form-control  custom-select custom-select-sm"
                  name="warehouse{{i}}">
            <option value="">Select Warehouse</option>
            <option *ngFor="let data of warehouse" class="ng-tns-c13-1 ng-star-inserted"
                    value="{{data.WAREHOUSE_ID}}">{{ data.WAREHOUSE_NAME }}
            </option>
          </select>
        </td>
        <td>
          <input [(ngModel)]="purchase.uom_arr_name[i]" [disabled]="purchases.check  != true" [readOnly]="true"
                 class="form-control  " name="uom_arr_name{{i}}" style="margin-bottom: 2px" tabindex="-1"
                 type="text">
          <input [(ngModel)]="purchase.order_quantity[i]" [disabled]="purchases.check  != true" [readOnly]="true"
                 class="form-control text-center " maxlength="8" name="order_quantity{{i}}" tabindex="-1"
                 type="text">
        </td>
        <td>
          <input (focusout)="getActualPrice();getUnitPrice();"
                 [(ngModel)]="purchase.purchased_quantity_arr[i]"
                 [disabled]="purchases.check  != true" class="form-control text-center "
                 maxlength="8" name="purchased_quantity_arr{{i}}" style="margin-bottom: 2px"
                 type="text">
          <input (focusout)="getActualPrice()" [(ngModel)]="purchase.freebie_arr[i]"
                 [disabled]="purchases.check  != true" class="form-control text-center " maxlength="8"
                 name="freebie_arr{{i}}" type="text">
        </td>
        <td>
          <input (focusout)="getUnitPrice();getAmount();getActualPrice();totalAmount()"
                 [(ngModel)]="purchase.amount_arr[i]"
                 [disabled]="purchases.check  != true" class="form-control text-right "
                 maxlength="10" name="amount_arr{{i}}" style="margin-bottom: 2px"
                 type="text">
          <input [(ngModel)]="purchase.actual_arr[i]" [disabled]="purchases.check  != true" [readonly]="true"
                 class="form-control text-right " maxlength="10" name="actual_arr{{i}}"
                 style="margin-bottom: 2px"
                 tabindex="-1" type="text">

        </td>
        <td>
          <input (focusout)=" getAmount();totalAmount()" [(ngModel)]="purchase.vat_arr[i]"
                   [disabled]="purchases.check  != true"
                   [readOnly]="true" class="form-control  text-right " maxlength="7"
                   name="vat_arr{{i}}" style="margin-bottom: 2px" tabindex="-1"
                   type="text">
            
        </td>
        <td>
          <input [(ngModel)]="purchase.gross_arr[i]" [disabled]="purchases.check  !== true" [readOnly]="true"
                 class="form-control  text-right " maxlength="7" name="vat_arr{{i}}"
                 style="margin-bottom: 2px"
                 tabindex="-1" type="text">
          <input [(ngModel)]="purchase.unitprice_arr[i]" [disabled]="purchases.check  !== true" [readOnly]="true"
                 class="form-control  text-right " maxlength="7" name="unitprice_arr{{i}}" tabindex="-1"
                 type="text">
        </td>
        <td>
          <input [(ngModel)]="purchase.retailprice_arr[i]" [disabled]="purchases.check  !== true"
                 class="form-control text-right  "
                 maxlength="7" name="retailprice_arr{{i}}" type="text">
        </td>
        <td>
          <div class="">
            <button (click)="addrow(i)" *ngIf="i == purchase_details.length-1" class="btn btn-success btn-sm mb-2 "
                    title="Add New data" type="button"><i class="fa fa-plus" style="color: white;"></i></button>
            <button (click)="deleterow(i)" *ngIf="purchase_details.length > 1" class="btn btn-danger  btn-sm "
                    title="Delete data" type="button"><i class="fa fa-trash" style="color: white;"></i></button>
          </div>
        </td>
      </tr>
      </tbody>
      <tfoot>
      <ng-container *ngIf="purchase.state_code != 32">
        <tr>
          <td colspan="7" style="text-align: right"><label>Gross Total&nbsp;&nbsp;&nbsp;</label></td>
          <td style="text-align: right;width:10%"><label>{{ total_amount | number : '1.2-2' }}</label></td>
        </tr>
        <tr>
          <td colspan="5" style="text-align: right"><label>Freight/Handling charge&nbsp;&nbsp; </label></td>
          <td>
            <input (focusout)="totalAmount()" [(ngModel)]="purchase.freight_charge"
                   class="form-control text-right " maxlength="9"
                   name="freight" style="height:33px" type="text">
          </td>
          <td style="text-align: right"><label>Discount&nbsp;&nbsp;&nbsp; </label></td>
          <div class="input-group mb-2">
            <input (focusout)="totalAmount()" [(ngModel)]="purchase.disc_per"
                   class="form-control text-right " maxlength="8"
                   name="dis_arr" style="height:33px" type="text">
            <div class="input-group-append">
              <label class="input-group-text day">
                (%)
              </label>
            </div>
          </div>
          <input (focusout)="totalAmount()" [(ngModel)]="purchase.discount" [readonly]="true"
                 class="form-control text-right "
                 maxlength="8" name="dis_arr" style="height:33px" type="text">
        </tr>
        <tr>
          <td colspan="7" style="text-align: right"><label>Net Total ({{env.CURRENCY}})&nbsp;&nbsp;&nbsp;</label>
          </td>
          <td style="text-align: right;width:10%"><label>{{ net_total | number : '1.2-2' }}</label></td>
        </tr>
      </ng-container>
      <ng-container *ngIf="purchase.state_code ==32">
        <tr>
          <td colspan="7" style="text-align: right"><label>Gross Total&nbsp;&nbsp;&nbsp;</label></td>
          <td style="text-align: right;width:10%"><label>{{ total_amount | number : '1.2-2' }}</label></td>
        </tr>
        <tr>
          <td colspan="5" style="text-align: right"><label>Freight/Handling charge&nbsp;&nbsp; </label></td>
          <td>
            <input (focusout)="totalAmount()" [(ngModel)]="purchase.freight_charge"
                   class="form-control text-right " maxlength="9"
                   name="freight" style="height:33px" type="text">
          </td>
          <td style="text-align: right"><label>Discount&nbsp;&nbsp;&nbsp; </label></td>
          <div class="input-group mb-2">
            <input (focusout)="totalAmount()" [(ngModel)]="purchase.disc_per"
                   class="form-control text-right " maxlength="7"
                   name="dis_arr" style="height:33px" type="text">
            <div class="input-group-append">
              <label class="input-group-text day">
                (%)
              </label>
            </div>
          </div>
          <input (focusout)="totalAmount()" [(ngModel)]="purchase.discount" [readonly]="true"
                 class="form-control text-right "
                 maxlength="8" name="dis_arr" style="height:33px" type="text">
        </tr>
        <tr>
          <td colspan="7" style="text-align: right"><label>Net Total&nbsp;&nbsp;&nbsp;</label>
          </td>
          <td style="text-align: right;width:10%"><label>{{ net_total | number : '1.2-2' }}</label></td>
        </tr>
      </ng-container>
      </tfoot>

    </table>

    <div class="row container">
      <div class="col-lg-7 pull-right">
        <button (click)="savePurchaseDetails();" *ngIf="user_rights.ADD == '1'"
                class="btn btn-info btn-sm ng-star-inserted"
                type="button">&nbsp;Save&nbsp;
        </button>
      </div>
    </div>
  </div>
</div>
